import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig'
import { AreaListResp } from 'domain/payload/response/area/AreaListResp';
import { AreaDetailResp } from 'domain/payload/response/area/AreaDetailResp';

const AreaService = () => {
  const areaList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<AreaListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/area/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const areaDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<AreaDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/area/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  return { areaList, areaDetail };
};

export default AreaService;